var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import ReactDOM from 'react-dom';
import ModalConfirm from './ModalConfirm';
export var destroyFns = [];
export default function confirm(config) {
    var container = document.createDocumentFragment();
    var currentConfig = __assign(__assign({}, config), { close: close, visible: true });
    function destroy() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        ReactDOM.unmountComponentAtNode(container);
        var triggerCancel = args.some(function (param) { return param === null || param === void 0 ? void 0 : param.triggerCancel; });
        if (config.onCancel && triggerCancel) {
            config.onCancel.apply(config, __spreadArray([], __read(args), false));
        }
        for (var i = 0; i < destroyFns.length; i++) {
            var fn = destroyFns[i];
            if (fn === close) {
                destroyFns.splice(i, 1);
                break;
            }
        }
    }
    function render(props) {
        /**
         * https://github.com/ant-design/ant-design/issues/23623
         *
         * Sync render blocks React event. Let's make this async.
         */
        setTimeout(function () {
            ReactDOM.render(React.createElement(ModalConfirm, __assign({}, props)), container);
        });
    }
    function close() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        currentConfig = __assign(__assign({}, currentConfig), { visible: false, afterClose: function () {
                if (typeof config.afterClose === 'function') {
                    config.afterClose();
                }
                destroy.apply(void 0, __spreadArray([], __read(args), false));
            } });
        render(currentConfig);
    }
    function update(configUpdate) {
        if (typeof configUpdate === 'function') {
            currentConfig = configUpdate(currentConfig);
        }
        else {
            currentConfig = __assign(__assign({}, currentConfig), configUpdate);
        }
        render(currentConfig);
    }
    render(currentConfig);
    destroyFns.push(close);
    return {
        destroy: close,
        update: update,
    };
}
//# sourceMappingURL=confirm.js.map